import { FormControl, Input, ListItemText, MenuItem, Select, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import React from 'react'

import Checkbox from '../Checkbox'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 250,
  },
  searchInput: {
    width: '100%',
    margin: 10,
    zIndex: 10000,
  },
})
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
}

class MultiSelectDropdown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onSearch = this.onSearch.bind(this)
    this.state = {
      vals: this.props.values || [],
      options: this.props.options || [],
      keyword: '',
    }
  }

  handleChange = event => {
    const { options } = this.props
    if (this.state.vals !== event.target.value) {
      this.setState({ vals: event.target.value }, () => {
        this.props.onChange(options.filter(option => this.state.vals.indexOf(option.value) > -1))
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.values && !_.isEqual(nextProps.values, this.props.values)) {
      this.setState({ vals: nextProps.values })
    }
  }

  onSearch(evt) {
    const keyword = evt.target.value
    if (!keyword) {
      return this.setState({
        options: this.props.options,
        keyword,
      })
    }
    return this.setState({
      keyword,
      // eslint-disable-next-line react/no-access-state-in-setstate
      options: this.state.options.filter(option => option.label.match(new RegExp(keyword, 'i'))),
    })
  }

  render() {
    const { classes, isShowFull } = this.props
    const { options, keyword } = this.state
    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl}>
          <Select
            multiple
            displayEmpty
            value={this.state.vals}
            onChange={this.handleChange}
            input={<Input />}
            renderValue={selected => {
              const selectedValues = options.filter(option => selected.indexOf(option.value) > -1).map(val => val.label)
              if (selectedValues.length > 3 && !isShowFull) {
                return `${selectedValues.length} selected`
              }
              if (selectedValues.length === 0) {
                return 'None selected'
              }
              return selectedValues.join(', ')
            }}
            MenuProps={MenuProps}
          >
            <TextField className={classes.searchInput} variant="outlined" value={keyword} onChange={this.onSearch} />
            {options.map(option => (
              <MenuItem key={option.value} value={option.value}>
                <Checkbox isChecked={this.state.vals.indexOf(option.value) > -1} />
                <ListItemText primary={option.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )
  }
}

MultiSelectDropdown.defaultProps = {
  options: [],
  onChange: () => {},
  values: [],
  isShowFull: false,
}

export default withStyles(styles)(MultiSelectDropdown)
